angular
	.module 'App.Repository'
	.factory 'TicketEventSessionOverrideRepository', ['BaseRepository', (BaseRepository) ->
		class TicketEventSessionOverrideRepository extends BaseRepository
			@resource = '/ticket_event_session_overrides'
			@isRestricted = true

		return new TicketEventSessionOverrideRepository
	]
